import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EWasteLegislationComponent} from './containers/country/e-waste-legislation/e-waste-legislation.component';
import {SystemsInCountryComponent} from './containers/country/systems-in-country/systems-in-country.component';
import {VisibleFeeComponent} from './containers/country/visible-fee/visible-fee.component';
import {ReUseTargetsComponent} from './containers/country/re-use-targets/re-use-targets.component';
import {WeeeTreatmentStandardMandatoryComponent} from './containers/country/weee-treatment-standard-mandatory/weee-treatment-standard-mandatory.component';
import {RetailVsMunicipalitiesVsOtherComponent} from './containers/country/retail-vs-municipalities-vs-other/retail-vs-municipalities-vs-other.component';
import {WeeeSystemRetailVsMunicipalitiesVsOtherComponent} from './containers/weeesystem/weee-system-retail-vs-municipalities-vs-other/weee-system-retail-vs-municipalities-vs-other.component';
import {MembersAdheredComponent} from './containers/weeesystem/members-adhered/members-adhered.component';
import {NetworkRecyclingFacilitiesComponent} from './containers/weeesystem/network-recycling-facilities/network-recycling-facilities.component';
import {CollectionPointsOperatedComponent} from './containers/weeesystem/collection-points-operated/collection-points-operated.component';
import {EmployeesPerProComponent} from './containers/weeesystem/employees-per-pro/employees-per-pro.component';
import {DownloadAtAGlanceComponent} from './components/download-at-a-glance/download-at-a-glance.component';
import {IntelligenceGuard} from './guards/intelligence.guard';

const routes: Routes = [
  {
    path: 'intelligence', canActivate: [IntelligenceGuard],
    children: [
      {
        path: 'country', children: [
          {path: 'e-waste-legislation', component: EWasteLegislationComponent},
          {path: 'systems-in-country', component: SystemsInCountryComponent},
          {path: 'visible-fee', component: VisibleFeeComponent},
          {path: 're-use-targets', component: ReUseTargetsComponent},
          {path: 'weee-treatment-standard-mandatory', component: WeeeTreatmentStandardMandatoryComponent},
          {path: 'retail-vs-municipalities-vs-other', component: RetailVsMunicipalitiesVsOtherComponent},
          {path: 'download', component: DownloadAtAGlanceComponent},
        ]
      },
      {
        path: 'countryadmin', children: [
          {path: 'e-waste-legislation', component: EWasteLegislationComponent},
          {path: 'systems-in-country', component: SystemsInCountryComponent},
          {path: 'visible-fee', component: VisibleFeeComponent},
          {path: 're-use-targets', component: ReUseTargetsComponent},
          {path: 'weee-treatment-standard-mandatory', component: WeeeTreatmentStandardMandatoryComponent},
          {path: 'retail-vs-municipalities-vs-other', component: RetailVsMunicipalitiesVsOtherComponent},
          {path: 'download', component: DownloadAtAGlanceComponent},
        ]
      },
      {
        path: 'weeesystem', children: [
          {path: 'retail-vs-municipalities-vs-other', component: WeeeSystemRetailVsMunicipalitiesVsOtherComponent},
          {path: 'members-adhered', component: MembersAdheredComponent},
          {path: 'network-recycling-facilities', component: NetworkRecyclingFacilitiesComponent},
          {path: 'collection-points-operated', component: CollectionPointsOperatedComponent},
          {path: 'employees-per-pro', component: EmployeesPerProComponent},
          {path: 'download', component: DownloadAtAGlanceComponent},
        ]
      },
      {
        path: 'weeesystemadmin', children: [
          {path: 'retail-vs-municipalities-vs-other', component: WeeeSystemRetailVsMunicipalitiesVsOtherComponent},
          {path: 'members-adhered', component: MembersAdheredComponent},
          {path: 'network-recycling-facilities', component: NetworkRecyclingFacilitiesComponent},
          {path: 'collection-points-operated', component: CollectionPointsOperatedComponent},
          {path: 'employees-per-pro', component: EmployeesPerProComponent},
          {path: 'download', component: DownloadAtAGlanceComponent},
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntelligenceRoutingModule { }
